// 事件追踪、反转专区、最新爆料流数据

export const featured = {
  category: "独家深度",
  title: "顶流男团“假唱”风波全记录：从一句质疑到全民要求鉴定的72小时",
  lead: "一段走音片段点燃舆论，随后原视频被删、声乐老师被扒、主办方沉默——我们把这场风波的每一条线索、每一次回应都按时间线拼了起来。",
  tag: "持续更新",
  updated: "今日 14:32 更新",
};

export const trackingList = [
  {
    id: "trk-1",
    category: "音乐",
    title: "「假唱风波」追踪：三方回应后，就差现场完整版",
    lead: "表演团队称“技术事故”，声乐老师已发声，主办方承诺调取全场录像。目前关键缺口是未经剪辑的完整现场音频。",
    progress: 62,
    stage: "鉴定进行中",
    latest: "主办方确认：完整母带已送第三方机构鉴定",
    milestone: ["11月2日 事发", "11月3日 团队回应", "11月5日 送鉴"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20concert%20stage%20with%20warm%20spotlights%20and%20a%20microphone%20silhouette%20while%20a%20large%20magnifying%20glass%20hovers%20above%20symbolizing%20audio%20verification%20crimson%20and%20amber%20tones%20cream%20background%20minimal%20vector%20style%20high%20contrast&width=900&height=600&seq=track-a1&orientation=landscape",
  },
  {
    id: "trk-2",
    category: "直播",
    title: "「带货翻车」追踪：品牌、主播、平台三边同步开火",
    lead: "产品质量存疑引发集中退货，主播连夜回应“绝无虚假宣传”，品牌方启动质检，平台客服窗口被挤爆。",
    progress: 41,
    stage: "多方交锋",
    latest: "品牌方公布第三方送检报告排期，预计一周内出结果",
    milestone: ["11月1日 争议起", "11月2日 主播回应", "11月4日 平台介入"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20smartphone%20showing%20a%20live%20shopping%20stream%20with%20comment%20bubbles%20and%20a%20shopping%20cart%20symbol%20while%20a%20trust%20seal%20badge%20and%20gavel%20hover%20around%20crimson%20amber%20tones%20cream%20background%20minimal%20flat%20vector%20high%20contrast&width=900&height=600&seq=track-b1&orientation=landscape",
  },
  {
    id: "trk-3",
    category: "影视",
    title: "「分镜抄袭」争议：导演逐帧回应后，网友开始扒相似度",
    lead: "导演称分镜表创作于三年前并晒出存档，质疑方同步放出对比动图，双方正围绕关键分镜的独创性展开拉锯。",
    progress: 27,
    stage: "证据拉锯",
    latest: "对比视频播放量破两千万，专业分镜师下场分析",
    milestone: ["10月30日 被曝抄袭", "11月2日 导演回应", "11月5日 专业分析"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20film%20clapperboard%20with%20storyboard%20sketches%20unrolled%20in%20front%20of%20it%20while%20two%20overlapping%20film%20frames%20are%20compared%20side%20by%20side%20crimson%20amber%20tones%20cream%20background%20minimal%20flat%20vector%20high%20contrast&width=900&height=600&seq=track-c1&orientation=landscape",
  },
];

export const reversalList = [
  {
    id: "rev-1",
    category: "反转更新",
    title: "“被传婚变”竟是乌龙：艺人晒全家同框，风波一夜平息",
    before: "此前传闻称两人长期分居，离婚协议被曝“已在走流程”。",
    after: "当事人晒出全家旅行合影并配文“谣言止于一张合照”，工作室同步确认，相关不实话题已陆续清理。",
    rate: "辟谣迅速",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20warm%20family%20silhouette%20standing%20together%20under%20a%20rising%20sun%20with%20a%20heart%20and%20handshake%20symbols%20clearing%20away%20storm%20clouds%20golden%20amber%20and%20cream%20tones%20minimal%20flat%20vector%20warm%20hopeful%20mood&width=900&height=600&seq=rev-a1&orientation=landscape",
  },
  {
    id: "rev-2",
    category: "反转更新",
    title: "“某公司大规模裁员”系误读：实为正常组织架构调整",
    before: "网传聊天截图称某互联网公司次日将“裁掉三分之一员工”，相关话题迅速登榜。",
    after: "公司正式回应实为部门合并与岗位重排，涉及人数不足网传十分之一，并公开了内部沟通记录作为佐证。",
    rate: "实为误读",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20modern%20office%20building%20blueprint%20being%20reorganized%20into%20neat%20blocks%20with%20an%20eraser%20removing%20a%20false%20rumor%20label%20amber%20crimson%20and%20cream%20tones%20minimal%20flat%20vector%20high%20contrast&width=900&height=600&seq=rev-b1&orientation=landscape",
  },
  {
    id: "rev-3",
    category: "反转更新",
    title: "网红“塌房”证据被证伪：所谓聊天记录系AI合成",
    before: "一段被广泛传播的“实锤聊天记录”引发大规模脱粉，话题登上热搜第一。",
    after: "多方技术鉴定与时间线核对显示记录存在拼接痕迹，原作者也已承认造假并公开道歉，事件迎来二次反转。",
    rate: "证据证伪",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20chat%20message%20screen%20shattering%20into%20pieces%20to%20reveal%20a%20verified%20shield%20with%20a%20checkmark%20inside%20symbolizing%20debunked%20fake%20evidence%20crimson%20amber%20cream%20tones%20minimal%20flat%20vector%20high%20contrast&width=900&height=600&seq=rev-c1&orientation=landscape",
  },
];

export const feedList = [
  {
    id: "f-1",
    category: "娱乐",
    title: "顶流男团经纪公司首度发声：愿配合一切调查并公开演出花絮",
    time: "18分钟前",
    source: "前线快讯",
    heat: 3284,
    digest: "经纪公司称已成立专项小组，将配合主办方、场地方完成完整录像核验，同时放出当日部分排练素材。",
  },
  {
    id: "f-2",
    category: "社会",
    title: "辟谣 | 网传“某超市大面积下架商品”不实，已恢复营业",
    time: "36分钟前",
    source: "核实组",
    heat: 2187,
    digest: "经实地走访与门店确认，所谓“大面积下架”实为常规补货调整，超市方已通过官方账号澄清。",
  },
  {
    id: "f-3",
    category: "直播",
    title: "头部主播再发声：质检报告公开前，相关商品先全部下架自查",
    time: "51分钟前",
    source: "前线快讯",
    heat: 2916,
    digest: "主播团队宣布暂停相关商品链接，主动送检并公开送检机构与批次信息，称“给消费者一个交代”。",
  },
  {
    id: "f-4",
    category: "商业",
    title: "品牌方启动代言人争议自查：合约合规性与商业条款将同步审查",
    time: "1小时前",
    source: "财经眼",
    heat: 1987,
    digest: "品牌负责人称内部法务与外部律师已介入，结果将尽快对外说明，期间不评论在谈合作细节。",
  },
  {
    id: "f-5",
    category: "影视",
    title: "导演晒三年前分镜存档，网友转攻“背景板相似度”继续扒",
    time: "2小时前",
    source: "影视角",
    heat: 2430,
    digest: "面对导演提供的创作时间线证据，部分网友转向逐帧比对背景板与道具细节，争议仍在持续升温。",
  },
  {
    id: "f-6",
    category: "综艺",
    title: "选秀节目退赛选手所属公司：尊重个人选择，暂不回应细节",
    time: "3小时前",
    source: "综艺派",
    heat: 1654,
    digest: "公司仅以一句话回应退赛传闻，未说明具体原因，节目组与平台方目前均保持沉默，引发更多猜测。",
  },
  {
    id: "f-7",
    category: "科技",
    title: "网传“某App监控用户聊天”被技术圈集体打假，开发者晒出源码",
    time: "4小时前",
    source: "科技派",
    heat: 1421,
    digest: "多名开发者指出所谓“监控”实为常规本地功能，并贴出开源代码片段，相关恐慌情绪正在回落。",
  },
  {
    id: "f-8",
    category: "体育",
    title: "争议判罚全记录：裁判协会宣布将公开比赛录像逐球复盘",
    time: "5小时前",
    source: "赛场观察",
    heat: 1267,
    digest: "面对球迷质疑，裁判协会首次承诺公开复盘，具体直播时间待定，吃瓜群早已备好瓜子。",
  },
  {
    id: "f-9",
    category: "民生",
    title: "“小区物业费上涨”引热议，业委会称下月召开公开听证会",
    time: "6小时前",
    source: "城事",
    heat: 1098,
    digest: "业主群流传的涨价明细被逐条核对后，物业方同意公开账目并召开听证会听取意见。",
  },
];

export const categories = ["全部", "娱乐", "社会", "直播", "商业", "影视", "综艺", "科技", "体育", "民生"];